import { store } from "../../store/store";
import React, { useEffect, useState } from 'react';
import { Text, View, ScrollView, Image, Pressable } from 'react-native';

import { checkIfShowA2shBtn, onPressA2HS } from "../../utils/services/A2HSUtils";
import { getImagePath, getMemberProfileURL, isChemistStoreLoaded, logoutAndReset } from "../../utils/services/CommonUtils";

import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { UserProfleFeatureWidget } from '../../utils/widgets/UserProfileUtils';
import { CommonRightChevronIcon, HorizontalDivider } from "../../utils/widgets/Common-Widget";

import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';
import AppStyles from "../../AppStyles";
import disableScroll from 'disable-scroll';
import Colors from "../../utils/constants/AppColors";

import ActionPopup from "../../utils/modals/ActionPopup";
import SupportViewModal from "../../utils/modals/SupportViewModal";

import ModalContent from "../../utils/constants/ModalContentConstant";

const ProfileComponent = (props) => {

    const reduxState = store.getState();
    const chemistStoreLoaded = isChemistStoreLoaded()
    const isUserLoggedIn = reduxState.isUserLogin ?? false
    const userDetails = reduxState.userDetails

    const [isShowA2hsCta, setIsShowA2hsCta] = useState(false)

    const [logoutPopup, setLogoutPopup] = useState(false)
    const [supportModal, setSupportModal] = useState(false)

    useEffect(() => {
        if (chemistStoreLoaded) checkIfShowA2shBtn(setIsShowA2hsCta);
    }, [])

    const showLogoutPopup = () => {
        setLogoutPopup(true)
    }

    const closeLogoutPopup = () => {
        disableScroll.off()
        setLogoutPopup(false)
    }

    const showSupportModal = () => {
        setSupportModal(true)
    }

    const closeSuportModal = () => {
        disableScroll.off()
        setSupportModal(false)
    }

    return (<ScrollView style={[{
        paddingBottom: AppTheme.bottomNavBarHeight
    }]} showsVerticalScrollIndicator={false}>
        {isUserLoggedIn ?
            <View style={[{
                paddingVertical: 28, paddingHorizontal: 16,
                backgroundColor: Colors.white
            }]}>
                <View style={[AppStyles.flexRowStart]}>
                    <Image style={{ borderRadius: 28 }} source={{
                        uri: getMemberProfileURL(userDetails),
                        width: 56, height: 56,
                    }} />
                    <View style={{ marginLeft: 16 }}>
                        <Text style={[TextStyle.text18xb, {
                            width: AppTheme.appWidth - 48 - 56
                        }]} numberOfLines={1}>
                            {userDetails['isNameCaptured'] ?
                                userDetails['name'] : 'Profile'}</Text>
                        <Text style={[TextStyle.text12, { marginTop: 4 }]}>
                            {userDetails['phoneNumber']}</Text>
                    </View>
                </View>
            </View> : <View style={[{
                paddingTop: 24, paddingBottom: 16,
                paddingHorizontal: 16, backgroundColor: Colors.white
            }]}>
                <View style={[AppStyles.flexRowStart, { marginBottom: 26 }]}>
                    <Image source={{
                        uri: getImagePath('/images/profile.png'),
                        width: 56, height: 56
                    }} />
                    <View style={{ marginLeft: 16 }}>
                        <Text style={TextStyle.text18xb}>Profile</Text>
                        <Text style={[TextStyle.text12, { marginTop: 4 }]}>
                            Login to see your complete profile</Text>
                    </View>
                </View>
                <PrimaryCTA text={'Login'} disabled={false}
                    onPress={() => { props.navigation.navigate(ScreenRoute.login); }} />
            </View>
        }

        {
            chemistStoreLoaded && isShowA2hsCta ?
                <Pressable style={[AppStyles.flexRowStart, AppStyles.borderView, {
                    backgroundColor: Colors.blue.bg,
                    borderColor: Colors.primary, marginHorizontal: 16,
                    paddingHorizontal: 16, paddingVertical: 16
                }]} onPress={() => onPressA2HS()}
                    onLongPress={() => { console.log('### long press') }}>
                    <Image style={{ height: 18, width: 18 }}
                        source={{
                            uri: getImagePath('/images/icons/a2hs_blue.svg')
                        }} />
                    <Text style={[TextStyle.text16b, {
                        color: Colors.primary, marginLeft: 16
                    }]}>Install the App</Text>
                </Pressable> : <View style={{
                    height: 16, width: AppTheme.appWidth,
                    backgroundColor: Colors.background
                }} />
        }


        <View style={[{
            backgroundColor: Colors.white,
            paddingHorizontal: 16,
            paddingTop: 18,
            paddingBottom: 24
        }]}>
            {
                isUserLoggedIn && <View>
                    <UserProfleFeatureWidget
                        onPress={() => {
                            props.navigation.navigate(
                                ScreenRoute.offers_list)
                        }}
                        title={'Offers'} iconName={'offers'} />
                    <HorizontalDivider
                        width={AppTheme.appWidth - 32}
                        marginVertical={18} />
                </View>
            }
            {
                isUserLoggedIn && <View>
                    <UserProfleFeatureWidget
                        onPress={() => {
                            props.navigation.navigate(
                                ScreenRoute.rewards_screen)
                        }}
                        title={'Rewards'} iconName={'rewards'} />
                    <HorizontalDivider
                        width={AppTheme.appWidth - 32}
                        marginVertical={18} />
                </View>
            }
            {
                isUserLoggedIn && <View>
                    <UserProfleFeatureWidget
                        onPress={() => {
                            props.navigation.navigate(
                                ScreenRoute.address_list)
                        }}
                        title={'Manage Addresses'} iconName={'manageAddress'} />
                    <HorizontalDivider
                        width={AppTheme.appWidth - 32}
                        marginVertical={18} />
                </View>
            }
            {chemistStoreLoaded ? null :
                isUserLoggedIn && <View>
                    <UserProfleFeatureWidget
                        onPress={() => {
                            props.navigation.navigate(
                                ScreenRoute.list_member)
                        }}
                        title={'Family Members'}
                        iconName={'manageFamily'} />
                    <HorizontalDivider
                        width={AppTheme.appWidth - 32}
                        marginVertical={18} />
                </View>
            }
            <Pressable onPress={() => showSupportModal()}
                style={[AppStyles.flexRowSpaceBetween]}>
                <UserProfleFeatureWidget onPress={() => showSupportModal()}
                    title={'Need Help?'} iconName={'support'} />
                {isUserLoggedIn ? null : CommonRightChevronIcon('black')}
            </Pressable>
            {
                isUserLoggedIn && <HorizontalDivider
                    width={AppTheme.appWidth - 32}
                    marginVertical={18} />
            }
            {chemistStoreLoaded ? null :
                isUserLoggedIn && <View>
                    <UserProfleFeatureWidget
                        onPress={() => { props.navigation.navigate(ScreenRoute.transaction_history) }}
                        title={'Aayu Cash & Transactions'}
                        iconName={'transaction'} />
                    <HorizontalDivider
                        width={AppTheme.appWidth - 32}
                        marginVertical={18} />
                </View>
            }
            {
                isUserLoggedIn && <UserProfleFeatureWidget
                    onPress={() => showLogoutPopup()}
                    title={'Logout'} iconName={'logout'} />
            }

        </View>

        <ActionPopup showPopup={logoutPopup}
            modalData={ModalContent.Logout}
            closeModal={closeLogoutPopup}
            primaryAction={() => logoutAndReset(props)} />

        <SupportViewModal showPopup={supportModal}
            closeModal={closeSuportModal} />

    </ScrollView>
    )
}

export default ProfileComponent;
